enum RecordingStateActions {
  Initialize,
  ChangeStep,
  SetTargetFolder,
  SetFileName,
  StartUpload,
  CompleteUpload,
  HandleError
}

export default RecordingStateActions;
